import React, { FC, useState } from 'react';
import { Button, Modal } from 'antd';
import { SearchInput } from 'common/components';
import { IAccount, IUpdateAccountBrandsPayload } from 'entities/Account/Account.models';
import { renderAccountOption, searchAccountsByName } from 'entities/Account/Account.helper';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  sellers: IAccount[];
  onCancel: () => void;
  onSubmit: (payload: Omit<IUpdateAccountBrandsPayload, 'brands'>) => void;
}

export const ManufacturerSelectModal: FC<IComponentProps> = ({ open, loading, sellers, onCancel, onSubmit }) => {
  const [search, setSearch] = useState<string>('');
  const [sellerId, setSellerId] = useState<number | null>(null);

  const filteredSellers = searchAccountsByName(sellers, search);

  const searchSeller = async (value?: string) => {
    if (value) {
      setSearch(value);
    } else {
      setSearch('');
    }
  };

  const selectSeller = (id: number) => {
    setSellerId(id);
  };

  const handleCancel = () => {
    if (loading) {
      return;
    }

    setSearch('');
    setSellerId(null);
    onCancel();
  };

  const handleSubmit = () => {
    if (!sellerId) {
      return;
    }

    onSubmit({ accountId: sellerId, onSuccess: handleCancel });
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={480}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      closeIcon={false}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel} loading={loading}>
          Отмена
        </Button>,
        <Button key="submit" className="button-sm primary" onClick={handleSubmit} loading={loading}>
          Сохранить
        </Button>,
      ]}
    >
      <div className="mb-3 ff-medium fs-m">Выберите производителя</div>

      <div className="mb-6 ff-regular fs-xs color-dark-grey">
        Производитель — это поставщик, связанный с брендом. Для бренда можно указать только 1 производителя.
      </div>

      <div className="mb-6">
        <SearchInput placeholder="Поиск по поставщикам" auto clearDeps={[open]} onSearch={searchSeller} />
      </div>

      {filteredSellers.length ? (
        <div className="pb-3 overflow-y-scroll scrollbar" style={{ height: 191 }}>
          {filteredSellers.map((item) => {
            const selected = item.id === sellerId;

            return renderAccountOption(item.name, item.id, selected, selectSeller);
          })}
        </div>
      ) : (
        <div className="my-11 flex align-center justify-center flex-1 ff-regular fs-xs color-dark-grey">
          Список производителей пуст
        </div>
      )}
    </Modal>
  );
};
